import moment from "moment";
import React from "react";

/** Shown when `date` is missing or not parseable. */
const EMPTY_DATE_PLACEHOLDER = "—";

function parseValidMoment(date: unknown) {
  if (date == null || date === "") return null;
  const m = moment(date);
  return m.isValid() ? m : null;
}

const DateTime = ({ date }: { date?: string | null }) => {
  const m = parseValidMoment(date);
  if (!m) {
    return <span>{EMPTY_DATE_PLACEHOLDER}</span>;
  }
  return (
    <span>
      {m.format("DD MMM Y")}
      <small className="text-muted ms-1">{m.format("hh:mm A")}</small>
    </span>
  );
};

const DateOnly = ({ date }: { date?: string | null }) => {
  const m = parseValidMoment(date);
  if (!m) {
    return <span>{EMPTY_DATE_PLACEHOLDER}</span>;
  }
  return <span>{m.format("DD MMM Y")}</span>;
};

export { DateTime, DateOnly };
